const requireModule = require.context('./', false, /.js$/);
const modules = requireModule.keys().filter(path => path !== './index.js').map(path => ({ path, module: requireModule(path).default }));

const headers = {};
_.each(modules, m => {
  const name = _.camelCase(m.path.replace(/^\.\//, '').replace(/\.\w+$/, ''));
  headers[name] = m.module;
});

export default headers;
